/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCortecStatusDto } from '../../models/lexplus-cortec-status-dto';

export interface CortecControllerTriggerRunV1$Params {
}

export function cortecControllerTriggerRunV1(http: HttpClient, rootUrl: string, params?: CortecControllerTriggerRunV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusCortecStatusDto>> {
  const rb = new RequestBuilder(rootUrl, cortecControllerTriggerRunV1.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusCortecStatusDto>;
    })
  );
}

cortecControllerTriggerRunV1.PATH = '/v1/cortec/sync';
